export const watch = {
  $route(to) {
    this.currentPath = to.path
  }
}
